import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from "../../box/src";
import { linkEffect } from "../../theme/src";
export const BreadcrumbItem = ({ fontStyle, hasUnderline = false, tab, }) => {
    const { active = false, disable = false, label, onClickAction } = tab;
    if (active) {
        return (_jsx(Box, { font: fontStyle, onClick: disable ? undefined : onClickAction, children: label }));
    }
    return (_jsx(Wrapper, { "$hasUnderline": hasUnderline, font: fontStyle, onClick: disable ? undefined : onClickAction, tabIndex: 0, children: label }));
};
const Wrapper = styled(Box) `
  ${({ $hasUnderline = false }) => $hasUnderline ? linkEffect() : undefined}
`;
//# sourceMappingURL=BreadcrumbItem.js.map